import type { BillingInterval, PaidTier } from "./api";

/**
 * D-071, D-072. The plans as the app describes them. Stripe's prices are what is actually charged; these are
 * for display only and must be kept in step with the prices behind the lookup keys in wrangler.jsonc.
 */

export const TRIAL_DAYS = 7;
/** D-072: the trial warning banner appears when the trial has this long or less to run. */
export const TRIAL_WARNING_MS = 48 * 60 * 60 * 1000;

export const PLAN_NAMES: Record<PaidTier, string> = { lite: "Lite", pro: "Pro" };

/** US cents. */
export const PLAN_PRICES_USD: Record<PaidTier, Record<BillingInterval, number>> = {
  lite: { monthly: 500, annual: 5000 },
  pro: { monthly: 2000, annual: 20000 },
};

/** "$5/month", "$200/year". Whole dollars drop their cents. */
export function planPriceLabel(tier: PaidTier, interval: BillingInterval): string {
  const cents = PLAN_PRICES_USD[tier][interval];
  const dollars = cents % 100 === 0 ? `$${cents / 100}` : `$${(cents / 100).toFixed(2)}`;
  return `${dollars}/${interval === "annual" ? "year" : "month"}`;
}
